import { DiscussionSortOption } from './types';

export enum DISCUSSION {
  QUESTIONS = 'questions',
  REVIEWS = 'reviews',
}

export enum DEAL_COMMENT_TYPE {
  REVIEW = 'dealreview',
  QUESTION = 'dealcomment',
}

export const QUESTION_SORT_OPTIONS: DiscussionSortOption[] = [
  { value: 'latest', label: 'Latest reply' },
  { value: 'helpful', label: 'Helpful' },
  { value: 'newest', label: 'Newest' },
  { value: 'oldest', label: 'Oldest' },
];

export const REVIEW_SORT_OPTIONS: DiscussionSortOption[] = [
  { value: 'newest', label: 'Newest' },
  { value: 'oldest', label: 'Oldest' },
  { value: 'rating:asc', label: 'Rating (Lowest)' },
  { value: 'rating:desc', label: 'Rating (Highest)' },
  { value: 'helpful', label: 'Helpful' },
];
